<template lang="pug">
  div.w-100
    loading-overlay(:is-loading="is_loading")
    section#creative_wrap
      div.alert.alert-danger(v-if="$v.form_data.$error") エラーが発生しました
      div.alert.alert-danger(v-if="submitErrorMessage") {{ submitErrorMessage }}
      div.form-group
        div.mb-2
          label.mb-0 名前
          span.badge.badge-primary.ml-2 *必須
        div.mb-1
          input.form-control.string.required(
            type='text',
            v-model='form_data.name',
            name='name',
            maxlength='255',
            :class="{ 'is-invalid': $v.form_data.name.$error, 'is-valid': !$v.form_data.name.$invalid && $v.form_data.name.$dirty }"
          )
          template(v-if="$v.form_data.name.$dirty && $v.form_data.name")
            .invalid-feedback(v-if="!$v.form_data.name.required") 名前を入力してください
          template(v-if="errorMessages.name")
            .invalid-feedback {{ errorMessages.name }}
      div.d-flex.justify-content-between
        div(style="width: 100%;")
          div.form-group(v-if="is_new_ui")
            div.mb-2
              label.mb-0 ポップアップ表示URL
              help-tooltip(html-key='displayUrl')
              span.badge.badge-primary.ml-2 *必須
            div(v-for="(path, index) in form_data.path_array" :key="index" class="align-items-center mb-2")
              div.d-flex
                input.form-control.mr-2(style="max-width: 60%;" type="text" v-model="path.url" placeholder="https://sitelead.net（URLを入力してください）" :disabled="isChainedScenarioPopup")
                template(v-if="!path.exclude")
                  select.form-control.custom-select.mr-2(style="max-width: 20%;" v-model="path.condition" :disabled="isChainedScenarioPopup")
                    option(value="equals") 等しい時表示
                    option(value="contains") 含む時表示
                  button.btn.btn-danger(style="max-width: 10%;" @click="removePath(index)"  v-if="index > 0") 削除
                template(v-else)
                  select.form-control.custom-select.mr-2(style="max-width: 20%;" v-model="path.condition")
                    option(value="equals") 等しい時除外
                    option(value="contains") 含む時除外
                  button.btn.btn-danger(style="max-width: 10%;" @click="removePath(index)"  v-if="index > 0") 削除

              .invalid-feedback(v-if="path.error") {{ path.error }}

              template(v-if="!path.exclude")
                p(style="color: green;" v-if="path.valid_url === true") タグの設置が確認できました。ポップアップ表示が可能です。
                p(style="color: red; white-space: pre-line;" v-if="path.valid_url === false")
                  | タグの設置が確認できませんでした。ポップアップ表示ができません。
                  | ポップアップ表示ページにタグが設置されているか確認してください。
                  | タグ設置方法は
                  a(href="/users/tag_domains") こちら
              template(v-else)
                p(style="color: green;" v-if="path.valid_url === true") タグの設置が確認できました。ポップアップ除外が可能です。
                p(style="color: red; white-space: pre-line;" v-if="path.valid_url === false")
                  | タグの設置が確認できませんでした。ポップアップ除外ができません。
                  | ポップアップ表示ページにタグが設置されているか確認してください。
                  | タグ設置方法は
                  a(href="/users/tag_domains") こちら

            button.btn.btn-primary(@click="addPath(false)" :disabled="isChainedScenarioPopup") 表示URLを追加
            button.btn.btn-primary.ml-2(@click="addPath(true)" :disabled="isChainedScenarioPopup") 表示除外URLを追加
            .mt-3
              .mb-1
                label.mb-0 パラメータ条件
                help-tooltip(html-key='queryParam')
              small.form-text.text-muted.d-block.mb-2(v-if="form_data.query_param_conditions.length > 0") パラメータ名（左辺）は完全一致、パラメータ値（右辺）は前方一致で表示の判別をします。パラメータ値が未入力の場合、パラメータ名の一致有無で判定します。
              div(v-for="(queryCondition, index) in form_data.query_param_conditions" :key="'query-condition-' + index" class="align-items-center mb-2")
                .d-flex
                  input.form-control.mr-2(style="max-width: 28%;" type="text" v-model="queryCondition.query_key" placeholder="パラメータ名（例：utm_source）")
                  span.align-self-center.text-muted.font-weight-bold(style="flex-shrink: 0; padding: 0 0.75rem; margin-right: 5px;") =
                  input.form-control.mr-2(style="max-width: 28%;" type="text" v-model="queryCondition.query_value" placeholder="パラメータ値（例：google）")
                  select.form-control.custom-select.mr-2(style="max-width: 20%;" v-model.number="queryCondition.exclude")
                    option(:value="0") 前方一致で表示
                    option(:value="1") 前方一致で除外
                  button.btn.btn-danger(style="max-width: 10%;" @click="removeQueryParamCondition(index)") 削除
                .invalid-feedback(v-if="queryCondition.error") {{ queryCondition.error }}
              button.btn.btn-primary.mt-2(type="button" @click="addQueryParamCondition()" :disabled="isChainedScenarioPopup") パラメータを追加

          div.form-group
            div.mb-2
              label.mb-0 クリエイティブ種類
              span.badge.badge-primary.ml-2 *必須
            div.form-check.mb-1
              input#creatives_target_blank.form-check-input(type='radio', v-model='form_data.creative_type', value='popup', name='popup')
              label.form-check-label(for='creatives_target_blank')
                | ポップアップ
                help-tooltip(html-key='popup')
            div.form-check.mb-1
              input#creatives_overlay.form-check-input(type='radio', v-model='form_data.creative_type', value='overlay', name='overlay', @change="form_data.position_rb = 0")
              label.form-check-label(for='creatives_overlay')
                | オーバーレイ（画面下）
                help-tooltip(html-key='overlayBottom')
            div.form-check.mb-1(v-if="is_new_ui")
              input#creatives_overlay_rb.form-check-input(type='radio', v-model='form_data.creative_type', value='overlay_rb', name='overlay_rb', @change="form_data.position_rb = 1")
              label.form-check-label(for='creatives_overlay_rb')
                | オーバーレイ（画面右下）
                help-tooltip(html-key='overlayBottomRight')
            div.form-check.mb-1(v-if="is_new_ui")
              input#creatives_scenario_popup.form-check-input(
                type='radio',
                v-model='form_data.creative_type',
                value='scenario_popup',
                name='scenario_popup',
                @change="form_data.position_rb = 0",
                @click="checkEnterprisePermission"
              )
              label.form-check-label(for='creatives_scenario_popup')
                | ポップアップ（シナリオ型）
                help-tooltip(html-key='scenarioPopup')
                span.upper-enterprise-label.ml-2 Enterprise以上
          div.form-group(v-if="form_data.creative_type")
            div.mb-2
              label.mb-0 表示条件
              span.badge.badge-primary.ml-2 *必須
            div.form-check.mb-1(v-if="!form_data.creative_type.includes('overlay')")
              input#leave_pre.form-check-input(type='radio', v-model='form_data.display_type', value='leave_pre')
              label.form-check-label(for='leave_pre')
                | Webサイト訪問後、離脱する時に表示
                help-tooltip(html-key='leavePre')
            div.form-check.mb-1(v-if="form_data.creative_type.includes('overlay')")
              input#always.form-check-input(type='radio', v-model='form_data.display_type', value='always')
              label.form-check-label(for='always')
                | 常時表示
            div.form-check.mb-1
              input#specific_position.form-check-input(type='radio', v-model='form_data.display_type', value='specific_position')
              label.form-check-label(for='specific_position')
                | Webサイト訪問後、特定の条件で表示
                help-tooltip(html-key='specificPosition')
            div.form-check.mb-1(v-if="form_data.creative_type.includes('overlay') && is_new_ui")
              input#popup_closed.form-check-input(type='radio', v-model='form_data.display_type', value='popup_closed')
              label.form-check-label(for='popup_closed')
                | 特定のポップアップを閉じた時
                help-tooltip(html-key='popupClosed')
            div.form-group(v-if="form_data.creative_type.includes('overlay') && is_new_ui && form_data.display_type === 'popup_closed'")
              label ポップアップID
              input.form-control(type="text", v-model="form_data.close_target_popup_id")
            div.form-check.mb-1(v-if="!form_data.creative_type.includes('overlay')")
              input#normal.form-check-input(type='radio', v-model='form_data.display_type', value='normal', @change="handleNormalDisplayType")
              label.form-check-label(for='normal')
                | Webサイト訪問直後に表示
            div.form-check.mb-1(v-if="form_data.creative_type === 'scenario_popup'")
              input#chained.form-check-input(type='radio', v-model='form_data.display_type', value='chained')
              label.form-check-label(for='chained')
                | 2つ目以降のポップアップとして使用
                help-tooltip(html-key='chained')

          div.form-group(v-if="is_new_ui && form_data.display_type === 'specific_position'")
            div.mb-2
              label.mb-0 条件詳細
              span.badge.badge-primary.ml-2 *必須
            div.form-check.mb-2
              input.form-check-input(type="radio" value="time" v-model="form_data.display_condition_detail" id="display_condition_detail_time" name="display_condition_detail")
              label.form-check-label(for="display_condition_detail_time")
                | 表示タイミングを指定する
                help-tooltip(html-key='displayTime')
            div.form-group(v-if="form_data.display_condition_detail === 'time'")
              .row.pl-4
                .col-12
                  div.form-group
                    label ページ表示から
                    div.row
                      .col-4
                        .input-group
                          input#time_limit_val.form-control(
                            type='text',
                            name='time_limit_val',
                            placeholder='秒数'
                            v-model="form_data.display_condition_value"
                            @input="convertToHalfWidth"
                            :class="{ 'is-invalid': $v.form_data.display_condition_value.$error }"
                          )
                          .input-group-append
                            span.input-group-text 秒
                      .col-5
                        p.text-muted.mt-1 経過した場合表示
                    .invalid-feedback.d-block(v-if="$v.form_data.display_condition_value.$dirty && !$v.form_data.display_condition_value.required") 秒数を入力してください
            div.form-check.mb-2
              input.form-check-input(type="radio" value="scroll" v-model="form_data.display_condition_detail" id="display_condition_detail_scroll" name="display_condition_detail")
              label.form-check-label(for="display_condition_detail_scroll")
                | 表示位置を指定する
                help-tooltip(html-key='displayScroll')
            div.form-check.mb-2(v-if="!form_data.creative_type.includes('overlay')")
              input.form-check-input(
                type="radio",
                value="phone_tap",
                v-model="form_data.display_condition_detail",
                id="display_condition_detail_phone_tap",
                name="display_condition_detail",
                @click="checkEnterprisePermission"
              )
              label.form-check-label(for="display_condition_detail_phone_tap")
                | 電話番号タップ時に表示する
                help-tooltip(html-key='phoneTap')
                span.upper-enterprise-label.ml-2 Enterprise以上
            div.form-group(v-if="form_data.display_condition_detail === 'scroll'")
              .row.pl-4
                .col-12
                  div.form-group
                    label ページ上部から
                    div.row
                      .col-4
                        .input-group
                          input#time_limit_val.form-control(
                            type='text',
                            name='time_limit_val',
                            placeholder='スクロール量'
                            v-model="form_data.display_condition_value"
                            @input="convertToHalfWidth"
                            :class="{ 'is-invalid': $v.form_data.display_condition_value.$error }"
                          )
                          .input-group-append
                            span.input-group-text %
                      .col-5
                        p.text-muted.mt-1 スクロールした場合表示
                    .invalid-feedback.d-block(v-if="$v.form_data.display_condition_value.$dirty && !$v.form_data.display_condition_value.required") スクロール量を入力してください
            div.form-group(v-if="form_data.display_condition_detail === 'phone_tap'")
              .row.pl-4
                .col-12
                  div.form-group
                    label 電話番号
                    input.form-control(
                      type='text',
                      name='phone_number',
                      placeholder='電話番号を入力してください（例：03-1234-5678）',
                      v-model="form_data.phone_number",
                      :class="{ 'is-invalid': $v.form_data.phone_number.$error, 'is-valid': !$v.form_data.phone_number.$invalid && $v.form_data.phone_number.$dirty }"
                    )
                    template(v-if="$v.form_data.phone_number.$dirty && $v.form_data.phone_number")
                      .invalid-feedback(v-if="!$v.form_data.phone_number.required") 電話番号を入力してください
                    template(v-if="errorMessages.phone_number")
                      .invalid-feedback {{ errorMessages.phone_number }}
            .invalid-feedback.d-block(v-if="$v.form_data.display_condition_detail.$dirty && !$v.form_data.display_condition_detail.required") 条件詳細を選択してください
          div.form-group(v-if="is_new_ui && !isChainedScenarioPopup")
            div.mb-2
              label.mb-0 表示日時
              span.upper-master-label.ml-2 Master以上
            div.form-check.mb-1
              input#no_specification.form-check-input(type='checkbox', v-model="form_data.is_no_specification", @change="resetSelections('no_specification')" value="1" :disabled="!form_data.is_limited_time && !form_data.is_specific_week_date")
              label.form-check-label(for='no_specification')
                | 指定なし
            div.form-check.mb-1
              input#limited_time_option.form-check-input(type='checkbox', v-model="form_data.is_limited_time", @change="resetSelections('limited_time')" value="1" @click="checkEditPermission")
              label.form-check-label(for='limited_time_option')
                | 表示開始・終了予約をする
            div.form-group(v-if="form_data.is_limited_time")
                .row.pl-4
                  .col-12
                    div.form-group
                      div.d-flex
                        .col-5
                          .input-group
                            input#limited_time_from.form-control(
                              type='datetime-local',
                              name='limited_time_from',
                              v-model="form_data.limited_time_from",
                              :class="{ 'is-invalid': form_data.limited_time && !form_data.limited_time_from }"
                            )
                            .invalid-feedback(v-if="errorMessages.limited_time_from") {{ errorMessages.limited_time_from }}
                        p.text-muted.mt-1 〜
                        .col-5
                          .input-group
                            input#limited_time_to.form-control(
                              type='datetime-local',
                              name='limited_time_to',
                              v-model="form_data.limited_time_to",
                              :class="{ 'is-invalid': form_data.limited_time && !form_data.limited_time_to || form_data.limited_time && form_data.limited_time_from && form_data.limited_time_to && new Date(form_data.limited_time_from) > new Date(form_data.limited_time_to) }"
                            )
                            .invalid-feedback(v-if="errorMessages.limited_time_to") {{ errorMessages.limited_time_to }}
            div.form-check.mb-1
              input#specific_week_date_option.form-check-input(type='checkbox', v-model="form_data.is_specific_week_date", @change="resetSelections('specific_week_date')" value="1" @click="checkEditPermission")
              label.form-check-label(for='specific_week_date_option')
                | 表示曜日・時間を指定する
            div.form-group(v-if="form_data.is_specific_week_date")
                .row.pl-4
                  .col-12
                    div.form-group(v-for="(weekday, index) in weekdays" :key="index")
                      input.form-check-input(type='checkbox', :id="'week_date_' + (index+1)", :name="'week_date_' + (index+1)", :checked="isSelectedWeekday(index+1)", @change="setCreativeDisplayWeekDate(index+1)")
                      div.d-flex.align-items-center.mb-3
                        label.form-check-label(:for="'week_date_' + (index+1)") {{ weekday }}
                      div.ml-3(v-if="isSelectedWeekday(index+1)")
                        div(v-for="(time, timeIndex) in getSelectedWeekdayTimes(index+1)" :key="timeIndex")
                          .row.mt-2
                            .col-5
                              input.form-control(type="time" v-model="time.time_from")
                            .col-1.text-center.pt-2 〜
                            .col-5
                              input.form-control(type="time" v-model="time.time_to")
                            .col-1.text-center.pt-2
                              i.fa.fa-times.text-danger(@click="removeSelectedTime(index+1, timeIndex)")
                          .invalid-feedback(v-if="time.error")
                            | {{ time.error }}
                        .row.mt-2
                          .col-12.text-center
                            button.btn.btn-sm.btn-outline-secondary.mr-4(@click="addSelectedTime(index+1)") + 追加
                    input#hide_holiday.form-check-input(type='checkbox', name='hide_holiday', @click='setHideHoliday', v-model="form_data.hide_holiday", value=1)
                    div.d-flex.align-items-center.mb-3
                      label.form-check-label(for='hide_holiday')
                        | 祝日にポップアップを表示しない
                        help-tooltip(html-key='hideHoliday')
            //div.mb-2(v-if="is_new_ui")
            //  div.d-flex.align-items-center
            //    label.mb-0 表示ターゲット
            //    span.upper-master-label.ml-2 Master以上
            //  div.form-group
            //    div.form-check.mb-3
            //      display-target(
            //        v-if="shouldRenderDisplayTarget"
            //        :key="displayTargetKey"
            //        :is-none-selected="Number(form_data.is_new_visitor == 0 && form_data.is_repeat_visitor == 0)"
            //        :is-new-visitor="form_data.is_new_visitor"
            //        :is-repeat-visitor="form_data.is_repeat_visitor"
            //        :froms="form_data.froms"
            //        @updateData="updateDisplayTargetData"
            //      )
            div.mb-2(v-if="is_new_ui && !isChainedScenarioPopup")
              label.mb-0 その他オプション
              span.upper-master-label.ml-2 Master以上
            div.form-group(v-if="is_new_ui && !isChainedScenarioPopup")
                div.form-check.mb-1
                  input#creatives_show_once.form-check-input(type='checkbox', v-model="form_data.show_once", value=1, @click="checkEditPermission")
                  label.form-check-label(for='creatives_show_once')
                    | 同一訪問者への表示を1回のみに制限する
                    help-tooltip(html-key='showOnce')
                div.form-check.mb-1(v-if="(form_data.creative_type === 'popup' || form_data.creative_type === 'scenario_popup') && form_data.display_type === 'leave_pre' && is_new_ui")
                  input#disable_on_welcome_back.form-check-input(type='checkbox', name='disable_on_welcome_back', v-model="form_data.disable_on_welcome_back", value=1, @click="checkEditPermission")
                  label.form-check-label(for='disable_on_welcome_back')
                    | ウェルカムバック（ページ復帰）による表示を無効にする
                    help-tooltip(html-key='disableWelcomeBack')
                div.form-check.mb-1(v-if="form_data.display_type === 'leave_pre' && is_new_ui")
                  input#disable_edge_swipe.form-check-input(type='checkbox', name='disable_edge_swipe', v-model="form_data.disable_edge_swipe", value=1, @click="checkEditPermission")
                  label.form-check-label(for='disable_edge_swipe')
                    | スワイプバックによる表示を無効にする
                div.form-check.mb-1(v-if="form_data.display_type === 'leave_pre' && is_new_ui")
                  input#disable_scroll_exit.form-check-input(type='checkbox', name='disable_scroll_exit', v-model="form_data.disable_scroll_exit", value=1, @click="checkEditPermission")
                  label.form-check-label(for='disable_scroll_exit')
                    | 上方向スクロールによる表示を無効にする
                    help-tooltip(html-key='disableScrollExit')
                div.form-check.mb-1(v-if="form_data.display_type === 'leave_pre'")
                  input#domain_check.form-check-input(type='checkbox', name='domain_check', v-model="form_data.domain_check", value=1, @click="checkEditPermission")
                  label.form-check-label(for='domain_check')
                    | 同一ドメインからのリターン訪問による表示を無効にする
                    help-tooltip(html-key='domainCheck')
                div.form-check.mb-1(v-if="showOverlayClickOption")
                  input#overlay_closed.form-check-input(type='checkbox', v-model="form_data.display_type_overlay_closed", value="1", @click="checkEditPermission")
                  label.form-check-label(for='overlay_closed')
                    | 特定のオーバーレイをクリックした時に表示する
                    help-tooltip(html-key='overlayClick')
                div.form-group.mb-3(v-if="showOverlayNumberOption")
                  overlay-id-select(
                    :overlays='overlays',
                    v-model='form_data.close_target_overlay_id'
                  )
                div.form-check.mb-1(v-if="form_data.creative_type !== 'overlay' &&  form_data.creative_type !== 'overlay_rb' &&  form_data.display_type === 'leave_pre'")
                  input#is_active_leave_optimize.form-check-input(type="checkbox" value="time" v-model="form_data.is_active_leave_optimize" @click="resetOptimizeType")
                  label.form-check-label(for="is_active_leave_optimize")
                    | AIスマホ離脱予測機能を有効にする
                    span.beta-label.ml-2 β版
                    help-tooltip(variant="warning" html-key='leaveOptimizeWarning')
                    help-tooltip(html-key='leaveOptimize')
                  div(v-if="is_error_optimize_heatmap")
                    p.invalid-feedback
                      | AI離脱予測機能は、ヒートマップの離脱データを活用するため、ポップアップを表示するWebサイトのURLをヒートマップ計測する必要があります。
                      br
                      | ヒートマップ計測は
                      a(href="/users/heatmaps" target="_blank") こちら
                  //- div(v-if="form_data.is_active_leave_optimize")
                  //-   div.form-check.mb-1.ml-1(v-for="optimize_type_option in optimize_type_options")
                  //-     input.form-check-input(type='radio' v-model='form_data.optimize_type' :value='optimize_type_option.value' :disabled="!form_data.is_active_leave_optimize")
                  //-     label.form-check-label(:for="'leave_optimize_' + optimize_type_option.value") {{ optimize_type_option.label }}
                  //-     div.form-group.mb-1.ml-1(v-if="form_data.is_active_leave_optimize && (form_data.optimize_type == 1 || form_data.optimize_type == 2)")
                  //-       div(v-if="form_data.optimize_type == optimize_type_option.value")
                  //-         label(for="dropdown") 最適化するCVを選択
                  //-         select.form-control#dropdown(v-model="form_data.cv_tag_id")
                  //-           option(v-for="cv_tag_with_site_page in cv_tags_with_site_pages"
                  //-                 :key="cv_tag_with_site_page.cv_tag.id"
                  //-                 :value="cv_tag_with_site_page.cv_tag.id")
                  //-             | {{ cv_tag_with_site_page.cv_tag.name }}
                  //-         template(v-if="$v.form_data.cv_tag_id.$dirty && $v.form_data.cv_tag_id")
                  //-           .invalid-feedback(v-if="!$v.form_data.cv_tag_id.required") CVを選択してください
                  //-   template(v-if="$v.form_data.optimize_type.$dirty && $v.form_data.optimize_type")
                  //-     .invalid-feedback(v-if="!$v.form_data.optimize_type.required") 最適化対象を選択してください
                div.form-check.mb-1(v-if="form_data.creative_type !== 'overlay' &&  form_data.creative_type !== 'overlay_rb' && form_data.display_type === 'leave_pre'")
                  input#is_active_creative_optimize.form-check-input(type="checkbox" value="time" v-model="form_data.is_active_creative_optimize" @click="resetOptimizeType")
                  label.form-check-label(for="is_active_creative_optimize")
                    | AIクリエイティブ自動最適化機能を有効にする
                    span.beta-label.ml-2 β版
                    help-tooltip(html-key='creativeOptimize')
                  div(v-if="form_data.is_active_creative_optimize")
                    div.form-check.mb-1.ml-1(v-for="optimize_type_option in optimize_type_options")
                      input.form-check-input(type='radio' v-model='form_data.optimize_type' :value='optimize_type_option.value' :disabled="!form_data.is_active_creative_optimize")
                      label.form-check-label(:for="'creative_optimize_' + optimize_type_option.value")
                        | {{ optimize_type_option.label }}
                        help-tooltip(v-if="optimize_type_option.value === 0" html-key='optimizeCtr')
                        help-tooltip(v-if="optimize_type_option.value === 2" html-key='optimizeCvr')
                    template(v-if="$v.form_data.optimize_type.$dirty && $v.form_data.optimize_type")
                      .invalid-feedback(v-if="!$v.form_data.optimize_type.required") 最適化対象を選択してください
          .form-check.mb-3(v-if="form_data.creative_type === 'overlay_rb'")
            input#show_on_overlay.form-check-input(
              type='checkbox',
              v-model='form_data.show_on_overlay'
              @click='checkEditPermission'
            )
            label.form-check-label(for='show_on_overlay')
              | 設置済オーバーレイの上に表示する
              help-tooltip(html-key='showOnOverlay')
          .form-group.mb-3(v-if="form_data.show_on_overlay && form_data.creative_type === 'overlay_rb'")
            label.form-check-label 設置済オーバーレイのセレクタ
            help-tooltip(html-key='overlaySelector')
            span.badge.badge-primary.ml-2 *必須
            input.form-control(
              type='text',
              v-model='form_data.selected_overlay_selector',
              placeholder='#id または .classname',
              :class="{ 'is-invalid': $v.form_data.selected_overlay_selector.$error, 'is-valid': !$v.form_data.selected_overlay_selector.$invalid && $v.form_data.selected_overlay_selector.$dirty }"
            )
            template(v-if="$v.form_data.selected_overlay_selector.$dirty && $v.form_data.selected_overlay_selector")
              .invalid-feedback(v-if="!$v.form_data.selected_overlay_selector.required") セレクタを入力してください
    upgrade-upper-master(v-if="is_upgrade_upper_master_modal", @close-modal="is_upgrade_upper_master_modal = false")
    upgrade-upper-enterprise(v-if="is_upgrade_upper_enterprise_modal", @close-modal="is_upgrade_upper_enterprise_modal = false")
    button.btn.btn-default(type='submit', @click='submit')
      span 登録する
</template>

<script>
import {required, helpers, requiredIf} from "vuelidate/lib/validators";
import PopupApi from "../apis/popup";
import ScenarioPopupApi from "../apis/scenario_popup";
import LimitedTimeOffer from "./creative_form/limited_time_offer.vue";
import SpecificWeekDate from "./creative_form/specific_week_date.vue";
import DisplayTarget from "./creative_form/display_target.vue";
import UpgradeUpperMaster from "./modals/upgrade_upper_master.vue";
import UpgradeUpperEnterprise from "./modals/upgrade_upper_enterprise.vue";
import LoadingOverlay from "./parts/loading_overlay.vue";
import OverlayIdSelect from "./creative_form/overlay_id_select.vue";
import { buildQueryStringFromKeyValue } from "../utils/queryParamKeyValue";

export default {
  props: {
    is_new_ui: Boolean,
    limit: {type: String, default: "10"},
    upper_master: Boolean,
    upper_enterprise: Boolean,
    overlays: {type: Array, default: () => []}
  },
  components: {
    LimitedTimeOffer,
    SpecificWeekDate,
    DisplayTarget,
    UpgradeUpperMaster,
    UpgradeUpperEnterprise,
    LoadingOverlay,
    OverlayIdSelect,
  },
  data() {
    return {
      is_loading: false,
      form_data: {
        name: '',
        creative_type: 'popup',
        display_type: 'leave_pre',
        display_type_overlay_closed: '',
        close_target_popup_id: '',
        close_target_overlay_id: '',
        path_array: [
          {
            url: '',
            condition: 'equals',
            exclude: 0
          }
        ],
        query_param_conditions: [],
        display_condition_value: '',
        display_condition_detail: '',
        domain: '',
        show_once: 0,
        domain_check: 0,
        is_new_visitor: 0,
        is_repeat_visitor: 0,
        display_date: null,
        froms: [],
        limited_time: 0,
        limited_time_from: new Date(new Date().getTime() + (9 * 60 * 60 * 1000)).toISOString().slice(0, 16),
        limited_time_to: '',
        specific_week_date: 0,
        hide_holiday: 0,
        week_dates: [],
        is_no_specification: 1,
        is_limited_time: 0,
        is_specific_week_date: 0,
        position_rb: 0,
        is_active_leave_optimize: false,
        is_active_creative_optimize: false,
        optimize_type: null,
        cv_tag_id: null,
        show_on_overlay: false,
        selected_overlay_selector: '',
        disable_on_welcome_back: false,
        disable_edge_swipe: false,
        disable_scroll_exit: false,
        phone_number: '',
      },
      url_options: [],
      weekdays: ['月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日', '日曜日'],
      optimize_type_options: [
        { value: 0, label: 'クリック数最大化' },
      //  { value: 1, label: 'CVR最適化' },
        { value: 2, label: 'CV数最大化' }
      ],
      display_visitors_question: false,
      is_upgrade_upper_master_modal: false,
      is_upgrade_upper_enterprise_modal: false,
      shouldRenderDisplayTarget: true,
      displayTargetKey: 0,
      errorMessages: {
        limited_time_from: '',
        limited_time_to: '',
        name: '',
        phone_number: ''
      },
      submitErrorMessage: '',
      is_error_optimize_heatmap: false,
    };
  },
  validations: {
    form_data: {
      name: {required},
      selected_overlay_selector: {
        required: requiredIf((form_data) => form_data.show_on_overlay)
      },
      optimize_type: {
        required: requiredIf((form_data) => form_data.is_active_creative_optimize)
      },
      phone_number: {
        required: requiredIf((form_data) => form_data.display_condition_detail === 'phone_tap')
      },
      display_condition_detail: {
        required: requiredIf(function (form_data) {
          return this.is_new_ui && form_data.display_type === 'specific_position';
        })
      },
      display_condition_value: {
        required: requiredIf(function (form_data) {
          return this.is_new_ui && (form_data.display_condition_detail === 'time' || form_data.display_condition_detail === 'scroll');
        })
      },
    }
  },
  watch: {
    'form_data.creative_type'(newVal, oldVal) {
      /* オーバーレイに切り替えた時、phone_tap が選択できなくなるため、display_type をリセット */
      if (newVal && newVal.includes('overlay') && this.form_data.display_type === 'phone_tap') {
        this.form_data.display_type = 'always';
        this.form_data.phone_number = '';
      }
      /* ポップアップに切り替えた時、always が選択できなくなるため、display_type をリセット */
      if (newVal && !newVal.includes('overlay') && this.form_data.display_type === 'always') {
        this.form_data.display_type = 'leave_pre';
      }
      /* オーバーレイに切り替えた時、display_condition_detail の phone_tap もリセット */
      if (newVal && newVal.includes('overlay') && this.form_data.display_condition_detail === 'phone_tap') {
        this.form_data.display_condition_detail = '';
        this.form_data.phone_number = '';
      }
    },
    'form_data.display_type'(newVal, oldVal) {
      /* display_typeが specific_position 以外に変更された時、display_condition_detail をリセット */
      if (newVal !== 'specific_position' && this.form_data.display_condition_detail === 'phone_tap') {
        this.form_data.display_condition_detail = '';
        this.form_data.phone_number = '';
      }
      if(newVal === 'leave_pre' && this.form_data.creative_type === 'scenario_popup') {
          this.form_data.display_condition_detail = '';
          this.form_data.display_condition_value = '';
      }
      if(newVal === 'chained') {
        this.form_data.display_condition_detail = '';
        this.form_data.display_condition_value = '';
        // 既存のURL自動セット
        const selectedDomainElement = document.querySelector('.custom-option');
        const domainValue = selectedDomainElement?.dataset?.value;
        if(domainValue) {
          this.form_data.path_array = [{ url: domainValue.trim(), condition: 'contains', exclude: 0 }];
        }
      }
    }
  },
  computed: {
    isChainedScenarioPopup() {
      return this.form_data.creative_type === 'scenario_popup' && this.form_data.display_type === 'chained';
    },
    showOverlayClickOption() {
      return this.form_data.creative_type === 'scenario_popup'
        && this.is_new_ui
        && this.form_data.display_condition_detail !== 'phone_tap'
    },
    showOverlayNumberOption() {
      return this.form_data.creative_type === 'scenario_popup'
        && this.is_new_ui
        && this.form_data.display_condition_detail !== 'phone_tap'
        && this.form_data.display_type_overlay_closed === true
    }
  },
  methods: {
    async submit() {
      this.clearErrorMessages();
      this.$v.$touch();

      if (this.is_new_ui) {
        if (!this.validateQueryConditions()) {
          return;
        }
        this.syncQueryParamConditionQueryFields();

        const promises = this.form_data.path_array.map((element, index) => {
          return this.checkUrl(index);
        });
        await Promise.all(promises);

        if (this.form_data.path_array.some(result => result?.error || result?.valid_url === false)) {
          return;
        }
        if (!this.validateDates()) {
          return;
        }
      }
      if (this.$v.form_data.$invalid) {
        return;
      }
      this.normalizeOverlayClickOption();
      try {
        this.is_loading = true;
        let response;
        if (this.form_data.creative_type === 'scenario_popup') {
          response = await ScenarioPopupApi.create(this.form_data);
          history.replaceState(null, '', '/users/popups');
        } else {
          response = await PopupApi.create(this.form_data);
          history.replaceState(null, '', '/users/popups');
        }
        window.location.href = `/users/popups/${response.data.url_token}/creatives/new`;
        this.is_loading = false;
      } catch (e) {
        const apiMessage = e?.response?.data?.message || e?.response?.data?.error || 'エラーが発生しました。時間をおいて再度お試しください。';

        if (e.response && e.response.status === 409) {
          this.$set(this.errorMessages, 'name', apiMessage);
        } else if (e.response && e.response.status === 422) {
          this.is_error_optimize_heatmap = true;
        } else {
          this.submitErrorMessage = apiMessage;
        }
        console.error("エラーが発生しました:", e.response?.data?.message || e.message);
        this.is_loading = false;
      }
    },
    async checkUrl(index) {
      const data = this.form_data.path_array[index];

      this.$set(this.form_data.path_array[index], 'valid_url', null);
      this.$set(this.form_data.path_array[index], 'error', null);

      if (data.url.length === 0) {
        this.$set(this.form_data.path_array[index], 'error', 'ポップアップを表示するURLを指定してください。');
        return;
      }

      if (data.url.startsWith('http://') || data.url.startsWith('https://')) {
        const selectedDomainElement = document.querySelector('.custom-option');
        const domainValue = selectedDomainElement?.dataset?.value;
        const userSelectedDomain = domainValue ? new URL(domainValue.trim()).hostname : null;

        try {
          const inputDomain = new URL(data.url).hostname;

          if (inputDomain !== userSelectedDomain) {
            this.$set(this.form_data.path_array[index], 'error', '選択されているWebサイトと一致しません。管理画面上部の「Webサイト」箇所をご確認ください。');
            return;
          }
        } catch (error) {
          this.$set(this.form_data.path_array[index], 'error', '選択されているWebサイトと一致しません。管理画面上部の「Webサイト」箇所をご確認ください。');
          return;
        }
      }
    },
    validateDates() {
      let isValid = true;

      // 限定時間の開始・終了のチェック
      if (this.form_data.is_limited_time) {
        const startDate = new Date(this.form_data.limited_time_from);
        const endDate = new Date(this.form_data.limited_time_to);

        if (!this.form_data.limited_time_from) {
          this.errorMessages.limited_time_from = "開始日時を入力してください";
          isValid = false;
        }
        if (!this.form_data.limited_time_to) {
          this.errorMessages.limited_time_to = "終了日時を入力してください";
          isValid = false;
        } else if (startDate >= endDate) {
          this.errorMessages.limited_time_to = "終了日時は開始日時より後にしてください";
          isValid = false;
        }
      }

      // 曜日ごとの時間範囲チェック
      if (this.form_data.is_specific_week_date) {
        this.form_data.week_dates.forEach((week, weekIndex) => {
          week.times.forEach((time) => {
            const fromTime = time.time_from;
            const toTime = time.time_to;
            if (!fromTime || !toTime || fromTime >= toTime) {
              time.error = "開始時間は終了時間より前にしてください";
              isValid = false;
            } else {
              time.error = ""; // エラーメッセージをクリア
            }
          });
        });
      }

      return isValid;
    },
    validateQueryConditions() {
      let isValid = true;

      this.form_data.query_param_conditions.forEach((queryCondition, index) => {
        this.$set(this.form_data.query_param_conditions[index], 'error', null);

        const keyTrim = (queryCondition.query_key || '').trim();
        const valueTrim = (queryCondition.query_value || '').trim();
        const built = buildQueryStringFromKeyValue(queryCondition.query_key, queryCondition.query_value);

        if (!built) return;

        if (!keyTrim && valueTrim) {
          this.$set(this.form_data.query_param_conditions[index], 'error', 'パラメータ名を入力してください。');
          isValid = false;
          return;
        }

        if (built.includes('?')) {
          this.$set(this.form_data.query_param_conditions[index], 'error', '?を除いたクエリ文字列を入力してください。');
          isValid = false;
        }
      });

      return isValid;
    },
    syncQueryParamConditionQueryFields() {
      this.form_data.query_param_conditions.forEach((row, index) => {
        const q = buildQueryStringFromKeyValue(row.query_key, row.query_value);
        this.$set(this.form_data.query_param_conditions[index], 'query', q);
      });
    },
    clearErrorMessages() {
      this.errorMessages = {
        limited_time_from: '',
        limited_time_to: '',
        phone_number: ''
      };
      this.submitErrorMessage = '';
    },
    addPath(exclude = false) {
      this.form_data.path_array.push({ condition: 'equals', url: '', exclude });
    },
    removePath(index) {
      this.form_data.path_array.splice(index, 1);
    },
    addQueryParamCondition() {
      this.form_data.query_param_conditions.push({
        query_key: '',
        query_value: '',
        query: '',
        condition: 'startsWith',
        exclude: 0
      });
    },
    removeQueryParamCondition(index) {
      this.form_data.query_param_conditions.splice(index, 1);
    },
    mouseOverVisitorsQuestion() {
      this.display_visitors_question = true;
    },
    mouseLeaveVisitorsQuestion() {
      this.display_visitors_question = false;
    },
    updateDisplayTargetData(data) {
      if (! this.upper_master) {
        this.is_upgrade_upper_master_modal = true;
        this.shouldRenderDisplayTarget = false;
        this.$nextTick(() => {
          this.displayTargetKey += 1;
          this.shouldRenderDisplayTarget = true;
        });
        return
      }

      this.form_data.is_new_visitor = data.is_new_visitor;
      this.form_data.is_repeat_visitor = data.is_repeat_visitor;
      this.form_data.froms = data.froms;
    },
    setHideHoliday(e) {
      this.form_data.hide_holiday = e.target.checked;
    },
    setCreativeDisplayWeekDate(weekNumber) {
      const weekDate = this.form_data.week_dates.find(date => date.week_number === weekNumber);
      if (this.isSelectedWeekday(weekNumber)) {
        weekDate.times = [];
      } else {
        if (weekDate) {
          weekDate.times.push({ time_from: "00:00", time_to: "23:59" });
        } else {
          this.form_data.week_dates.push({ week_number: weekNumber, times: [{ time_from: "00:00", time_to: "23:59" }] });
        }
      }
    },
    isSelectedWeekday(weekNumber) {
      const weekDate = this.form_data.week_dates?.find(date => date.week_number === weekNumber);
      return weekDate && weekDate.times.length > 0;
    },
    getSelectedWeekdayTimes(weekNumber) {
      const weekDate = this.form_data.week_dates.find(date => date.week_number === weekNumber);
      return weekDate ? weekDate.times : [];
    },
    addSelectedTime(weekNumber) {
      const weekDate = this.form_data.week_dates.find(date => date.week_number === weekNumber);
      if (weekDate && weekDate.times.length >= 2) {
        alert("1つの曜日に設定できる時間は2件までです。");
        return;
      }
      if (weekDate) {
        weekDate.times.push({ time_from: "00:00", time_to: "23:59" });
      } else {
        this.form_data.week_dates.push({
          week_number: weekNumber,
          times: [{ time_from: "00:00", time_to: "23:59" }]
        });
      }
    },
    removeSelectedTime(weekNumber, timeIndex) {
      const weekDate = this.form_data.week_dates.find(date => date.week_number === weekNumber);
      if (weekDate) {
        weekDate.times.splice(timeIndex, 1);
        if (weekDate.times.length === 0) {
          this.form_data.week_dates = this.form_data.week_dates.filter(date => date.week_number !== weekNumber);
        }
      }
    },
    checkEditPermission(e) {
      if (! this.upper_master) {
        this.is_upgrade_upper_master_modal = true;
        e.preventDefault();
      }
    },
    checkEnterprisePermission(e) {
      if (! this.upper_enterprise) {
        this.is_upgrade_upper_enterprise_modal = true;
        e.preventDefault();
      }
    },
    resetSelections(selectedOption) {
      if (selectedOption === 'no_specification') {
        if (this.form_data.is_no_specification) {
          this.form_data.is_limited_time = 0;
          this.form_data.is_specific_week_date = 0;

          this.form_data.limited_time_from = ''
          this.form_data.limited_time_to = ''
        }
      } else if (['limited_time', 'specific_week_date'].includes(selectedOption)) {
        if (Boolean(this.form_data.is_specific_week_date) || Boolean(this.form_data.is_limited_time)){
          this.form_data.is_no_specification = 0;
        } else {
          this.form_data.is_no_specification = 1;
        }

        if(! Boolean(this.form_data.is_limited_time)) {
            this.form_data.limited_time_from = new Date(new Date().getTime() + (9 * 60 * 60 * 1000)).toISOString().slice(0, 16);
            this.form_data.limited_time_to = '';
        }

        if(! Boolean(this.form_data.is_specific_week_date)) {
          this.form_data.week_dates = []
          this.form_data.hide_holiday = 0
        }
      }
    },
    convertToHalfWidth(event) {
      const halfWidthValue = event.target.value
        .replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
        .replace(/[^0-9]/g, '');

      this.form_data.display_condition_value = halfWidthValue;
    },
    resetOptimizeType(e) {
      if (!this.upper_master) {
        e.preventDefault();
        this.is_upgrade_upper_master_modal = true;
        return;
      }

      if (!(this.form_data.is_active_leave_optimize || this.form_data.is_active_creative_optimize)) {
        this.form_data.optimize_type = null;
        this.form_data.cv_tag_id = null;
      }
    },
    handleNormalDisplayType() {
      this.form_data.display_condition_detail = 'immediate';
    },
    normalizeOverlayClickOption() {
      if (!this.form_data.display_type_overlay_closed) {
        this.form_data.close_target_overlay_id = null;
      }
    }
  }
};
</script>

<style scoped>
button:disabled {
  background-color: #cccccc !important;
  border-color: #cccccc !important;
  color: #666666 !important;
  opacity: 1 !important;
}
</style>
